// extracted by mini-css-extract-plugin
export default {"logo":"LoginPage_logo__RDyLM","loader":"LoginPage_loader__QdQqK","loginPage":"LoginPage_loginPage__NH1nj"};